import {
  DataLoadingView,
  SectionedHorizontalLinedTable,
  SwitchAppButton,
} from "../../components";
import { SectionedHeader } from "../../components/SectionedHorizontalLinedTable/SectionedHeader";
import { ThreeLeveledSection } from "../../components/SectionedHorizontalLinedTable/ThreeLeveledSection";
import { ActivationRequiredWarning } from "../../components";
import visa from "../../assets/icons/visa.png";
import mcard from "../../assets/icons/mcard.png";
import Amex from "../../assets/icons/amex.png";
import Discover from "../../assets/icons/Discover.png";

import card from "../../assets/icons/card.svg";
import bank from "../../assets/icons/bank.svg";
import ussd from "../../assets/icons/ussd.svg";
import code from "../../assets/icons/code.svg";

// import paypalLogo from "../../assets/icons/paypalLogo.svg";
// import googleLogo from "../../assets/icons/googleLogo.svg";
// import samsungPayLogo from "../../assets/icons/samsumgPayLogo.svg";
// import appleLogo from "../../assets/icons/appleLogo.svg";

import { IPaymentMethodViewProps } from "./PaymentMethod";
import { paymentMethod } from "../../enums";

export const View = ({
  hideActivationRequired,

  isLoadingToggleDvaBank,
  isLoadingToggleGateway,
  isLoadingTogglePaymentMethod,
  toggleDvaBank,
  toggleGateway,
  togglePaymentMethod,

  isLoadingSupportedDvaBanks,
  isLoadingSupportedGateways,
  isLoadingSupportedPaymentMethods,
  supportedDvaBanksStatusList,
  supportedGatewaysStatusList,
  supportedPaymentMethods: supportedPaymentMethodsStatusList,
  goBack,
  isDirty,

  handleSubmit,
  errors,
  register,
}: IPaymentMethodViewProps) => {
  const isPaymentMethodSliderChecked = (payment_method: paymentMethod) =>
    supportedPaymentMethodsStatusList.find(
      (pm) => pm.payment_method === payment_method
    )?.is_enabled || false;

  return (
    <form onSubmit={handleSubmit}>
      {hideActivationRequired ? null : (
        <ActivationRequiredWarning
          title="Please you need to activate your profile"
          subtitle="0ur guide will help you complete your Business profile and you’ll start receiving payments. Click this banner to complete your set-up"
          urlTarget="/onboarding"
        />
      )}

      <SectionedHorizontalLinedTable>
        <SectionedHeader hasBorder={true} mainHead="Commonly used" subHead="" />
        <ThreeLeveledSection
          hasBorder={true}
          titleLogo={<img alt="card type" src={card} />}
          rightFirstItem="Cards"
          rightSecondItem="Popular for consumers and businesses to pay online. SwitchApp supports global and local card networks."
          rightThirdItem={
            <div className="flexed-icon">
              <img alt="visa" src={visa} />
              <img alt="mastercard" src={mcard} />
              <img alt="discover" src={Discover} />
              <img alt="amex" src={Amex} />
            </div>
          }
          checked={isPaymentMethodSliderChecked(paymentMethod.card)}
          onToggle={() =>
            togglePaymentMethod({
              payment_method: paymentMethod.card,
              is_enabled: !isPaymentMethodSliderChecked(paymentMethod.card),
            })
          }
          isLoading={isLoadingTogglePaymentMethod}
        />
        <ThreeLeveledSection
          hasBorder={true}
          titleLogo={<img alt="bank" src={bank} />}
          rightFirstItem="Bank Transfer"
          rightSecondItem="SwitchApp supports payments using bank transfers."
          rightThirdItem={""}
          checked={isPaymentMethodSliderChecked(paymentMethod.bank)}
          onToggle={() =>
            togglePaymentMethod({
              payment_method: paymentMethod.bank,
              is_enabled: !isPaymentMethodSliderChecked(paymentMethod.bank),
            })
          }
          isLoading={isLoadingTogglePaymentMethod}
        />
        <ThreeLeveledSection
          hasBorder={true}
          titleLogo={<img alt="ussd" src={ussd} />}
          rightFirstItem="USSD Transfer"
          rightSecondItem="Enable customers to complete payments using USSD codes."
          rightThirdItem={""}
          checked={isPaymentMethodSliderChecked(paymentMethod.ussd)}
          onToggle={() =>
            togglePaymentMethod({
              payment_method: paymentMethod.ussd,
              is_enabled: !isPaymentMethodSliderChecked(paymentMethod.ussd),
            })
          }
          isLoading={isLoadingTogglePaymentMethod}
        />
        <ThreeLeveledSection
          hasBorder={false}
          titleLogo={<img alt="qr code" src={code} />}
          rightFirstItem="QR code"
          rightSecondItem="Allow your customers make payment quickly by scanning QR codes."
          rightThirdItem={""}
          // checked={true}
          checked={isPaymentMethodSliderChecked(paymentMethod.qrCode)}
          onToggle={() =>
            togglePaymentMethod({
              payment_method: paymentMethod.qrCode,
              is_enabled: !isPaymentMethodSliderChecked(paymentMethod.qrCode),
            })
          }
          isLoading={isLoadingTogglePaymentMethod}
        />

        <SectionedHeader
          className="more-margin"
          hasBorder={true}
          mainHead="Gateways"
          subHead="These settings apply to payment pages you create using SwitchApp Checkout and Payment Links."
        />

        {isLoadingSupportedGateways ? (
          <DataLoadingView
            message="Loading payment providers..."
            className="payment-providers-loader"
          />
        ) : (
          supportedGatewaysStatusList.map((gwItem) => (
            <ThreeLeveledSection
              key={gwItem.gateway_code}
              hasBorder={true}
              titleLogo={
                <img
                  alt="gateway"
                  src={`/gateway-logos/${gwItem.gateway_code}-icon.svg`}
                  className="gateway-logo"
                />
              }
              rightFirstItem={gwItem.gateway_name}
              rightSecondItem={`Enable customers to pay with ${gwItem.gateway_name}`}
              rightThirdItem={""}
              checked={gwItem.is_enabled}
              onToggle={() =>
                toggleGateway({
                  gateway_code: gwItem.gateway_code,
                  is_enabled: !gwItem.is_enabled,
                })
              }
              isLoading={isLoadingTogglePaymentMethod}
            />
          ))
        )}

        <SectionedHeader
          className="more-margin"
          hasBorder={true}
          mainHead="Reserved Account Banks"
          subHead="These settings determine which banks are shown to your customers on SwitchApp Checkouts and Payment Links."
        />

        {isLoadingSupportedDvaBanks ? (
          <DataLoadingView
            message="Loading reserved account banks..."
            className="payment-providers-loader"
          />
        ) : (
          supportedDvaBanksStatusList.map((bank) => (
            <ThreeLeveledSection
              key={bank.bank_code}
              hasBorder={true}
              titleLogo={
                <img
                  alt="bank"
                  src={`/bank-logos/${bank.bank_code}.svg`}
                  className="gateway-logo"
                />
              }
              rightFirstItem={bank.bank_name}
              rightSecondItem={`Enable customers to pay with ${bank.bank_name}`}
              rightThirdItem={""}
              checked={bank.is_enabled}
              onToggle={() =>
                toggleDvaBank({
                  bank_code: bank.bank_code,
                  is_enabled: !bank.is_enabled,
                })
              }
              isLoading={isLoadingTogglePaymentMethod}
            />
          ))
        )}

        {/* <SectionedHeader
          className="more-margin"
          hasBorder={true}
          mainHead="Wallets"
          subHead="These settings apply to payment pages you create using SwitchApp Checkout and Payment Links."
        />

        <ThreeLeveledSection
          hasBorder={true}
          titleLogo={<img src={paypalLogo} />}
          rightFirstItem="Paypal"
          rightSecondItem="Popular for consumers and businesses to pay online or in person. SwitchApp supports global and local card networks."
          rightThirdItem={""}
        />

        <ThreeLeveledSection
          hasBorder={true}
          titleLogo={<img src={googleLogo} />}
          rightFirstItem="Google Pay"
          rightSecondItem="Popular for consumers and businesses to pay online or in person. SwitchApp supports global and local card networks."
          rightThirdItem={""}
        />

        <ThreeLeveledSection
          hasBorder={true}
          titleLogo={<img src={appleLogo} />}
          rightFirstItem="Apple Pay"
          rightSecondItem="Popular for consumers and businesses to pay online or in person. SwitchApp supports global and local card networks."
          rightThirdItem={""}
        />

        <ThreeLeveledSection
          hasBorder={true}
          titleLogo={<img src={samsungPayLogo} />}
          rightFirstItem="Samsung Pay"
          rightSecondItem="Popular for consumers and businesses to pay online or in person. SwitchApp supports global and local card networks."
          rightThirdItem={""}
        /> */}

        {hideActivationRequired ? null : (
          <div className="payment-method--footer flex-container flex-break--small justify-content--between">
            <div className="flex-container justify-content--between align-items--end">
              {/* <img src={info} />
            <div>
              To set up payment methods that require routing action,{" "}
              <Link to={`/settings/payment-routing`} className="switchapp-link">
                please click here.
              </Link>
            </div> */}
            </div>

            <div className="flex-container justify-content--end mt-5">
              <SwitchAppButton size="sm" kind="secondary" onClick={goBack}>
                Cancel
              </SwitchAppButton>
            </div>
          </div>
        )}
      </SectionedHorizontalLinedTable>
    </form>
  );
};
